import React from "react";
import OccupantsList from "./occupantsList";
import { withBottombar } from "../../HOCs";

class OccupantsParent extends React.Component {
  render() {
    return <OccupantsList {...this?.props} />;
  }
}

const props = {
  top_bar: "title_bar",
}

export default withBottombar(OccupantsParent, props);
